import { FunctionComponent, useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import classnames from 'classnames';

import Button, { ButtonElements, ButtonLayouts, ButtonSizes, ButtonStyles, ButtonVariants } from 'components/layout/Button';
import Form from 'components/layout/forms/Form';
import Input from 'components/layout/forms/Input';
import LayoutContainer from 'components/layout/LayoutContainer';

import { Props } from './index';
import StyledComponent from './style';

const PublicLayoutFormsSearchEmployeeArticlesForm: FunctionComponent<Props> = ({
    title,
    placeholder,
    categories,
    onSearch,
    icon,
}) => {
    const [mobileView, setMobileView]: [boolean, Function] = useState(false);
    const router = useRouter();

    return (
        <StyledComponent className='public-layout-form-articlesemployee-form'>
            <LayoutContainer>
                <div
                    className="categories-list-header"
                    onClick={() => setMobileView(!mobileView)}
                >
                    {title}
                    <img
                        src={mobileView
                            ? '/images/icons/arrow-down.svg'
                            : '/images/icons/arrow-up.svg'}
                        className="arrow-down"
                        loading="lazy"
                        width="24"
                        height="27"
                    />
                </div>
                <div className={classnames(
                    'form-articles-search',
                    { 'visible': mobileView }
                )}
                >
                    <div className="categories-list">
                        <div
                            className="title-categorie-list"
                            dangerouslySetInnerHTML={{ __html: title }}
                        />
                        <ul className="form-categories-list">
                            {categories && categories.length > 0 && (categories
                                .map(category => (
                                    <li
                                        key={category.id}
                                        className={classnames(
                                            'form-categories-el',
                                        )}
                                    >
                                        <Button
                                            href={category.href}
                                            layout={ButtonLayouts.Default}
                                            element={ButtonElements.Anchor}
                                            size={ButtonSizes.Small}
                                            variant={category.slug === router?.query?.articleCategorySlug
                                                ? ButtonVariants.Primary
                                                : ButtonVariants.Outline
                                            }
                                            style={category.slug === router?.query?.articleCategorySlug
                                                ? ButtonStyles.Primary
                                                : ButtonStyles.Light
                                            }
                                        >
                                            {category.name}
                                        </Button>
                                        <div className="mobile-link">
                                            <Link
                                                href={category.href}
                                                prefetch={false}
                                            >
                                                {category.name}
                                            </Link>
                                        </div>
                                    </li>
                                )))}
                        </ul>
                    </div>
                    {/* <Form
                        submitAction={async (values) => {
                            try {
                                const response = true;
                                response && onSearch(true)

                            // return response;
                            } catch (error) {
                                console.error(error);
                                return null;
                            }
                        }}
                        onSuccess={onSearch}
                    >
                        {({ formik }) => {
                            return (
                                <div className="input-icon-wrapper">
                                    {icon && (
                                        <img src={icon} />
                                    )}
                                    <Input
                                        type='text'
                                        name='search'
                                        placeholder={placeholder}
                                        onChange={formik.handleChange}
                                        value={formik.values.search}
                                    />
                                </div>
                            )
                        }}
                    </Form> */}
                </div>
            </LayoutContainer>
            <div className="form-mobile">
                <LayoutContainer>
                    <Form
                        submitAction={async () => {
                            try {
                                const response = true;
                                response && onSearch(true);

                                // return response;
                            } catch (error) {
                                console.error(error);
                                return null;
                            }
                        }}
                        onSuccess={onSearch}
                    >
                        {({ formik }) => {
                            return (
                                <div className="input-icon-wrapper">
                                    {icon && (
                                        <img
                                            src={icon}
                                            loading="lazy"
                                        />
                                    )}
                                    <Input
                                        type='text'
                                        name='search'
                                        onChange={formik.handleChange}
                                        value={formik.values.search}
                                        placeholder={placeholder}
                                    />
                                </div>
                            );
                        }}
                    </Form>
                </LayoutContainer>
            </div>
        </StyledComponent>
    );
};

export default PublicLayoutFormsSearchEmployeeArticlesForm;